import React from 'react'
import PropTypes from 'prop-types'
import { map, isEmpty } from 'lodash'

import { DEFAULT_USER_TYPE } from 'components/SegmentSelector/UserTypeSelector'
import MessageSection from './MessageSection'
import EmptyState from './EmptyState'

export const UserTypeMessageSection = ({ messages, hasMessages, getMessages }) => (
  <div className="messages-user-type-section">
    {hasMessages ? (
      map(messages, (section) => {
        if (!isEmpty(section.messages)) {
          return (
            <MessageSection
              className="section"
              key={section.trigger}
              sectionType={section.trigger}
              messages={section.messages}
              onChange={getMessages}
            />
          )
        }
      })
    ) : (
      <EmptyState />
    )}
  </div>
)

UserTypeMessageSection.propTypes = {
  messages: PropTypes.array.isRequired,
  hasMessages: PropTypes.bool.isRequired,
  userType: PropTypes.string.isRequired,
  getMessages: PropTypes.func.isRequired,
}

UserTypeMessageSection.defaultProps = {
  messages: [],
  hasMessages: false,
  userType: DEFAULT_USER_TYPE,
}

export default UserTypeMessageSection
